export const GET_AURORA_DIVISION = 'GET_AURORA_DIVISION';
export const LOADING_AURORA_DIVISION = 'LOADING_AURORA_DIVISION';
export const SAVE_LOADER_AURORA_DIVISION = 'SAVE_LOADER_AURORA_DIVISION'
export const FORM_FAIL = "FORM_FAIL";
export const AURORA_DIVISION_FAIL = 'AURORA_DIVISION_FAIL';